// import { apiSlice } from '../api/apiSlice'
// import 

import { id } from "date-fns/locale";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const BATCHES_BASE = "/batches";
const buildUrl = (endpoint) => BATCHES_BASE + endpoint;

const batchesApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        createBatch: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body,
                // headers: {
                //     "from_app":true
                // }
            }),
            providesTags: () => [{ type: 'Batches' }],
        }),
        updateBatch: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/${body.id}`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Batch'}, {type: 'Batch', id: arg.id}],
        }),
        deleteBatch: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/${body.id}`),
                method: 'DELETE',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Batch'}, {type: 'Batch', id: arg.id}],
        }),
       
    })
});

export const {
    useCreateBatchMutation,
    useUpdateBatchMutation,
    useDeleteBatchMutation,
  } = batchesApiSlice;
